import React from "react";
import "./DefaultContent.scss";

const DefaultContent = () => {
  return (
      <div className="default-content-wrapper">
        <p className="default-text">Select Post for details</p>
      </div>
  );
};

export default DefaultContent;
